//////////////////
// Responsive Controller
// ------------
// All standard functions for responsive behaviours
//////////////////
App.Responsive = (function() {

	// Constants
	var options = {
		navSelector: ".nav-mobile .nav-mobile-pane",
		btnSelector: ".nav-mobile button",
		hiddenClass: "hidden"
	}

	// Variables
	var mobileNav, mobileBtn;


	/*
	Toggle handler
	*/
	function toggleMobileNavigation() {
		var state = mobileNav.hasClass(options.hiddenClass);
		App.log("Mobile menu: " + (state ? "Opening" : "Closing"));

		if(state) {
			mobileNav.removeClass(options.hiddenClass);
		} else {
			mobileNav.addClass(options.hiddenClass);
		}
	}


	/*
	Add click handlers to mobile navigation
	*/
	function addMobileNavigationHandlers() {
		try {
			mobileNav = $(options.navSelector);
			mobileBtn = $(options.btnSelector);
		} catch(e) {
			throw new Error("Couldn't find mobile navigation or control")
		}

		if(mobileNav && mobileBtn) {
			mobileBtn.on("click", toggleMobileNavigation);
			// App.addEventListener("click", mobileBtn, toggleMobileNavigation);
		}

	}


	App.register(function() {
		App.log("Registered: App.Responsive");
		//
		addMobileNavigationHandlers();
	});


	return {
		// Public methods
	}

})();
